import { BRANCH, HOST } from './env'

import { ReactComponent as IdenficationSignalsSVG } from '../img/MenuIcons/IdentificationSignalsSVG.svg'
import { ReactComponent as SmartSignalsSVG } from '../img/MenuIcons/SmartSignalsSVG.svg'
import { ReactComponent as MobileAppSignalsSVG } from '../img/MenuIcons/MobileAppSignalsSVG.svg'
import { ReactComponent as BotDetectionSVG } from '../img/MenuIcons/BotDetectionSVG.svg'
import { ReactComponent as DeviceIntelligenceSVG } from '../img/MenuIcons/DeviceIntelligenceSVG.svg'

import { ReactComponent as PaymentFraudSVG } from '../img/MenuIcons/PaymentFraudSVG.svg'
import { ReactComponent as AccountSharingSVG } from '../img/MenuIcons/AccountSharingSVG.svg'
import { ReactComponent as PaywallSVG } from '../img/MenuIcons/PaywallSVG.svg'
import { ReactComponent as ImproveConversionSVG } from '../img/MenuIcons/ImproveConversionSVG.svg'

import { ReactComponent as FintechSVG } from '../img/MenuIcons/FintechSVG.svg'
import { ReactComponent as EcommerceSVG } from '../img/MenuIcons/EcommerceSVG.svg'
import { ReactComponent as BuyNowSVG } from '../img/MenuIcons/BuyNowSVG.svg'
import { ReactComponent as OnlineGamingSVG } from '../img/MenuIcons/OnlineGamingSVG.svg'
import { ReactComponent as CryptocurrencySVG } from '../img/MenuIcons/CryptocurrencySVG.svg'

import { ReactComponent as DocumentationSVG } from '../img/MenuIcons/DocumentationSVG.svg'
import { ReactComponent as SDKsAndLibrariesSVG } from '../img/MenuIcons/SDKsAndLibrariesSVG.svg'
import { ReactComponent as OpenSourceSVG } from '../img/MenuIcons/OpenSourceSVG.svg'
import { ReactComponent as TutorialsSVG } from '../img/MenuIcons/TutorialsSVG.svg'
import { ReactComponent as PlaygroundSVG } from '../img/MenuIcons/PlaygroundSVG.svg'
import { ReactComponent as IdentificationOverviewSVG } from '../img/MenuIcons/IdentificationOverviewSVG.svg'
import { ReactComponent as ByUseCaseSVG } from '../img/MenuIcons/ByUseCaseSVG.svg'

import { ReactComponent as ResourcesCenterSVG } from '../img/MenuIcons/ResourceCenterSVG.svg'
import { ReactComponent as BlogSVG } from '../img/MenuIcons/BlogSVG.svg'
import { ReactComponent as WebinarsSVG } from '../img/MenuIcons/WebinarsSVG.svg'
import { ReactComponent as FaqSVG } from '../img/MenuIcons/FaqSVG.svg'
import { ReactComponent as CaseStudiesSVG } from '../img/MenuIcons/CaseStudiesSVG.svg'
import { ReactComponent as PressSVG } from '../img/MenuIcons/PressSVG.svg'
import { ReactComponent as AboutUsSVG } from '../img/MenuIcons/AboutUsSVG.svg'
import { ReactComponent as CareersSVG } from '../img/MenuIcons/CareersSVG.svg'
import { ReactComponent as SupportSVG } from '../img/MenuIcons/SupportSVG.svg'

import { ReactComponent as AccountTakeoverSVG } from '../img/MenuIcons/AccountTakeoverSVG.svg'
import { ReactComponent as SMSFraudSVG } from '../img/MenuIcons/SMSFraudSVG.svg'
import { ReactComponent as NewAccountFraudSVG } from '../img/MenuIcons/NewAccountFraudSVG.svg'
export const BASE_URL = HOST

export const PATH = {
  home: '/',
  homeTestA: '/home-a/',
  homeTestB: '/home-b/',
  demoUrl: '/demo/',
  pricingUrl: '/pricing/',
  accountTakeover: '/account-takeover/',
  ecommerce: '/e-commerce/',
  gaming: '/gaming/',
  cryptocurrency: '/cryptocurrency/',
  paymentFraud: '/payment-fraud/',
  blog: '/blog/',
  paywall: '/paywall/',
  caseStudies: '/case-studies/',
  contactSales: '/contact-sales/',
  whyFpjs: '/products/fingerprint-pro/',
  identification: '/products/identification/',
  accountSharing: '/products/account-sharing-prevention/',
  botD: '/products/bot-detection/',
  bnpl: '/buy-now-pay-later/',
  careers: '/careers/',
  jobs: '/careers/jobs/',
  support: '/support/',
  security: '/security/',
  useCases: '/blog/tag/use-cases/',
  tutorials: '/blog/tag/tutorials/',
  guides: '/blog/tag/guides/',
  resources: '/resources/',
  faq: '/resources/frequently-asked-questions-faqs/',
  press: '/resources/press/',
  vsThreatMetrix: '/resources/comparisons/compare-fingerprint-vs-threatmetrix/',
  vsShield: '/resources/comparisons/compare-fingerprint-vs-shield/',
  vsTruValidate: '/resources/comparisons/compare-fingerprint-vs-truvalidate/',
  integrations: '/integrations/',
  sdks: '/sdk-libraries/',
  github: '/github/',
  aboutUs: '/about-us',
  smartSignals: '/products/smart-signals/',
  partners: '/partners/',
  finserv: '/fintech',
  smsFraud: '/sms-fraud/',
  personalization: '/blog/providing-personalization-to-anonymous-users/',
  couponPromo: '/blog/prevent-coupon-promo-abuse-increase-sales/',
  credentialStuffing: '/blog/stop-credential-stuffing/',
  start: '/start/',
  newAccountFraudPrevention: '/new-account-fraud-prevention/',
  mobileAppDetection: '/mobile-app-detection/',
  improveConversionRates: '/improve-conversion-rates/',
} as const

export const USE_CASE_PATH = {
  personalization: '/blog/providing-personalization-to-anonymous-users/',
  accountSharing: '/blog/increase-revenue-identifying-preventing-account-sharing/',
  paymentFraud: '/blog/reducing-payment-fraud-with-reliable-visitor-identification/',
  credentialStuffing: '/blog/stop-credential-stuffing/',
} as const

export const URL = {
  githubRepoUrl: 'https://github.com/fingerprintjs/fingerprintjs/',
  githubApiUrl: 'https://api.github.com/repos/fingerprintjs',
  githubCommunityRepoUrl: 'https://github.com/fingerprintjs/home',
  botDRepoUrl: 'https://github.com/fingerprintjs/BotD',
  botDIntegrationsRepoUrl: 'https://github.com/fingerprintjs/botd-integrations',
  dashboardLoginUrl: 'https://dashboard.fingerprint.com/login',
  careersUrl: 'https://boards.greenhouse.io/fingerprintjs/',
  careersConsoleLogUrl: 'https://grnh.se/bb9c55804us',
  linkedinUrl: 'https://www.linkedin.com/company/fingerprintjs/',
  twitterUrl: 'https://twitter.com/FingerprintJs/',
  signupUrl: 'https://dashboard.fingerprint.com/signup',
  statusUrl: 'https://status.fingerprint.com',
  supportMail: 'support@fingerprint.com',
  salesMail: 'sales@fingerprint.com',
  worKMail: 'work@fingerprint.com',
  pressMail: 'press@fingerprint.com',
  securityMail: 'security@fingerprint.com',
  discordServerURL: 'https://discord.gg/ad6R2ttHVX',
  docsUrl: 'https://dev.fingerprint.com',
  promotionalVideo: 'https://www.youtube.com/embed/UEYBysyPTBs',
  demoVideo: 'https://www.youtube.com/embed/hVktdWfyBuU',
  g2ReviewUrl: 'https://www.g2.com/products/fingerprintjs-fingerprint/reviews',
  hubUrl: 'https://demo.fingerprint.com/',
} as const

export const DEMO_URL = {
  smartSignals: `${URL.hubUrl}playground/`,
  couponFraud: `${URL.hubUrl}coupon-fraud/`,
  credentialStuffing: `${URL.hubUrl}credential-stuffing/`,
  loanRisk: `${URL.hubUrl}loan-risk/`,
  paymentFraud: `${URL.hubUrl}payment-fraud`,
  paywall: `${URL.hubUrl}paywall/`,
  personalization: `${URL.hubUrl}personalization/`,
  webScraping: `${URL.hubUrl}web-scraping/`,
} as const

export const MAILTO = { mailToUrl: `mailto:${URL.supportMail}` } as const
export const MAILTO_WORK = { mailToUrl: `mailto:${URL.worKMail}` } as const
export const MAILTO_SALES = { mailToUrl: `mailto:${URL.salesMail}` } as const
export const MAILTO_SECURITY = { mailToUrl: `mailto:${URL.securityMail}` } as const

// links to readme should not have trailing slash to prevent forwarding
export const DOC_URL = {
  documentationUrl: URL.docsUrl,
  proVsOpenUrl: `${URL.docsUrl}/docs/pro-vs-open-source`,
  browserFingerprintUrl: `${URL.docsUrl}/docs/browser-fingerprinting`,
  incognitoUrl: `${URL.docsUrl}/docs/incognito-private-mode-detection`,
  serverApiUrl: `${URL.docsUrl}/docs/server-api`,
  legalUrl: `${URL.docsUrl}/docs/dpa-gdpr`,
  termOfUseUrl: `${URL.docsUrl}/docs/terms-of-service`,
  privacyPolicyUrl: `${URL.docsUrl}/docs/privacy-policy`,
  browserSupportUrl: `${URL.docsUrl}/docs/browser-support`,
  webhooksUrl: `${URL.docsUrl}/docs/webhooks`,
  botDUrl: 'https://github.com/fingerprintjs/BotD#botd',
  zeroTrustUrl: `${URL.docsUrl}/docs/zero-trust-mode`,
  bestPracticesUrl: `${URL.docsUrl}/docs/best-practices`,
  migrateUrl: `${URL.docsUrl}/docs/migrating-from-open-source-v3`,
  botDetectionGuide: `${URL.docsUrl}/docs/bot-detection-quick-start-guide`,
  jsAgent: `${URL.docsUrl}/reference/javascript-agent`,
  quickStartCustomSubdomain: `${URL.docsUrl}/docs/custom-subdomain-setup`,
  quickStartWebhooks: `${URL.docsUrl}/docs/webhooks`,
  quickStartServerApi: `${URL.docsUrl}/docs/server-api`,
  pricing: `${URL.docsUrl}/docs/pricing`,
  serverApi: `${URL.docsUrl}/reference/pro-server-api`,
  smartSignalsMobile: `${URL.docsUrl}/docs/smart-signals-reference#smart-signals-for-mobile-devices`,
  gettingStartedMobile: `${URL.docsUrl}/docs/getting-started-tutorials`,
} as const

export const INTEGRATIONS_URL = {
  android: `${URL.docsUrl}/docs/native-android-integration`,
  angular: `${URL.docsUrl}/docs/angular`,
  flutter: `${URL.docsUrl}/docs/flutter`,
  go: `${URL.docsUrl}/docs/fingerprint-pro-server-api-go-sdk`,
  ios: `${URL.docsUrl}/docs/ios`,
  js: `${URL.docsUrl}/reference/javascript-agent`,
  ts: `${URL.docsUrl}/reference/javascript-agent#typescript-support`,
  next: `${URL.docsUrl}/docs/fingerprintjs-pro-nextjs`,
  node: `${URL.docsUrl}/docs/fingerprintjs-pro-server-api-nodejs-sdk`,
  openApi: `${URL.docsUrl}/docs/openapi-for-server-api-and-webhooks`,
  preact: `${URL.docsUrl}/docs/preact`,
  python: `${URL.docsUrl}/docs/python-server-api-sdk`,
  react: `${URL.docsUrl}/docs/fingerprintjs-pro-react`,
  reactNative: `${URL.docsUrl}/docs/fingerprintjs-pro-react-native`,
  svelte: `${URL.docsUrl}/docs/svelte`,
  vue: `${URL.docsUrl}/docs/vuejs`,
  gtm: `${URL.docsUrl}/docs/fingerprintjs-pro-google-tag-manager`,
  cloudflare: `${URL.docsUrl}/docs/cloudflare-integration-new-accounts`,
  chrome: `${URL.docsUrl}/docs/fingerprintjs-pro-and-chrome-extension`,
  java: `${URL.docsUrl}/docs/java-server-api-sdk`,
  kotlin: `${URL.docsUrl}/docs/android-sdk`,
  swift: `${URL.docsUrl}/docs/ios`,
} as const

export const developers = [
  { title: 'Documentation', url: DOC_URL.documentationUrl, isLocal: false },
  { title: 'Tutorials', url: PATH.tutorials, isLocal: true },
  { title: 'SDKs and Libraries', url: PATH.sdks, isLocal: true },
  { title: 'GitHub', url: URL.githubRepoUrl, isLocal: false },
  { title: 'Discord Community', url: URL.discordServerURL, isLocal: false },
]

export const product = [
  { title: 'Device Intelligence Platform', url: PATH.whyFpjs, isLocal: true },
  { title: 'Smart Signals', url: PATH.smartSignals, isLocal: true },
  { title: 'Integrations', url: PATH.integrations, isLocal: true },
  { title: 'FingerprintJS vs. Pro', url: PATH.github, isLocal: true },
  { title: 'Demo', url: PATH.demoUrl, isLocal: true },
  { title: 'Identification', url: PATH.identification, isLocal: true },
  { title: 'Pricing', url: PATH.pricingUrl, isLocal: true },
]

export const resources = [
  { title: 'Resource Center', url: PATH.resources, isLocal: true },
  { title: 'Blog', url: PATH.blog, isLocal: true },
  { title: 'Case Studies', url: PATH.caseStudies, isLocal: true },
  { title: 'Guides', url: PATH.guides, isLocal: true },
  { title: 'FAQ', url: PATH.faq, isLocal: true },
  { title: 'Support Center', url: PATH.support, isLocal: true },
]

export const useCases = [
  { title: 'New Account Fraud', url: PATH.newAccountFraudPrevention, isLocal: true },
  { title: 'Account Takeover', url: PATH.accountTakeover, isLocal: true },
  { title: 'Account Sharing Prevention', url: PATH.accountSharing, isLocal: true },
  { title: 'SMS Fraud', url: PATH.smsFraud, isLocal: true },
  { title: 'Payment Fraud', url: PATH.paymentFraud, isLocal: true },
  { title: 'Paywall Enforcement', url: PATH.paywall, isLocal: true },
  { title: 'Personalization', url: PATH.personalization, isLocal: true },
  { title: 'Bot Detection', url: PATH.botD, isLocal: true },
]

export const defaultDataLayer = [{ branch: BRANCH }]

// When changing this, some markdown files need to be changed as well.
export const DEFAULT_TRIAL_DAYS = 14

export const THOUSAND_IDENTIFICATIONS_PRICE = 4

export const solutionsDropdown = {
  protect: [
    {
      title: 'Payment Fraud',
      url: PATH.paymentFraud,
      description: 'Reduce fraud. Increase real payments.',
      useCasesLink: USE_CASE_PATH.paymentFraud,
      icon: PaymentFraudSVG,
    },
    {
      title: 'Account Takeover',
      url: PATH.accountTakeover,
      description: 'Prevent attacks without hindering UX.',
      icon: AccountTakeoverSVG,
    },
    {
      title: 'SMS Fraud',
      url: PATH.smsFraud,
      description: 'Stop SMS fraud and SMS pumping.',
      icon: SMSFraudSVG,
    },
    {
      title: 'New Account Fraud',
      url: PATH.newAccountFraudPrevention,
      description: 'Stop repeat signups and trial abuse.',
      icon: NewAccountFraudSVG,
    },
  ],
  grow: [
    {
      title: 'Returning User Experience',
      url: PATH.improveConversionRates,
      description: 'Tailor experiences. Remove friction.',
      icon: ImproveConversionSVG,
    },
    {
      title: 'Account Sharing Prevention',
      url: PATH.accountSharing,
      description: 'Convert users into paying customers.',
      useCasesLink: USE_CASE_PATH.accountSharing,
      icon: AccountSharingSVG,
    },
    {
      title: 'Paywall',
      url: PATH.paywall,
      description: 'Eliminate bypass techniques.',
      icon: PaywallSVG,
    },
  ],
}

export const industryDropdown = [
  { title: 'Fintech', url: PATH.finserv, icon: FintechSVG },
  { title: 'eCommerce', url: PATH.ecommerce, icon: EcommerceSVG },
  { title: 'Buy Now Pay Later (BNPL)', url: PATH.bnpl, icon: BuyNowSVG },
  { title: 'Online Gaming & Gambling', url: PATH.gaming, icon: OnlineGamingSVG },
  { title: 'Cryptocurrency', url: PATH.cryptocurrency, icon: CryptocurrencySVG },
]

export const devResourcesDropdown = [
  { title: 'Documentation', url: DOC_URL.documentationUrl, icon: DocumentationSVG },
  { title: 'SDKs and Libraries', url: PATH.sdks, icon: SDKsAndLibrariesSVG },
  // { title: 'API Status', url: URL.statusUrl },
  { title: 'Tutorials', url: PATH.tutorials, icon: TutorialsSVG },
  { title: 'FingerprintJS vs Pro', url: PATH.github, icon: OpenSourceSVG },
  // { title: 'Use Case Demos', url: PATH.useCases, icon: UseCaseDemosSVG },
]

export const communityDropdown = [
  { title: 'Discord', url: URL.discordServerURL },
  { title: 'GitHub', url: URL.githubCommunityRepoUrl },
]

export const platformDropdown = {
  capabilities: [
    {
      title: 'Device Intelligence',
      url: PATH.whyFpjs,
      description: 'Recognize web and mobile users.',
      icon: DeviceIntelligenceSVG,
    },
    {
      title: 'Customizable insights',
      url: '/blog/product-update-customizable-insights/',
      description: 'Understand site visitors: New Smart Signals data and suspect score weights',
      isNew: true,
    },
  ],
  integrations: [
    {
      title: 'Identification',
      url: PATH.identification,
      description: 'Industry-leading accuracy.',
      icon: IdenficationSignalsSVG,
    },
    {
      title: 'Smart Signals',
      url: PATH.smartSignals,
      description: '100+ signals for fraud & user intent.',
      icon: SmartSignalsSVG,
    },
    {
      title: 'Mobile Device Signals',
      url: PATH.mobileAppDetection,
      description: 'Identify suspicious mobile traffic.',
      icon: MobileAppSignalsSVG,
    },
    {
      title: 'Bot Detection',
      url: PATH.botD,
      description: 'Prevent sophisticated attacks.',
      icon: BotDetectionSVG,
    },
    // {
    //   title: 'Integrations',
    //   url: PATH.integrations,
    //   description: 'Seamless, third-party integrations help you get started quickly.',
    // },
  ],
}

export const resourcesDropdown = [
  { title: 'Resources', url: PATH.resources, icon: ResourcesCenterSVG },
  { title: 'Blog', url: PATH.blog, isLocal: true, icon: BlogSVG },
  { title: 'Webinars', url: `${PATH.blog}tag/webinar/`, isLocal: true, icon: WebinarsSVG },
  { title: 'FAQ', url: PATH.faq, isLocal: true, icon: FaqSVG },
  { title: 'Case Studies', url: PATH.caseStudies, isLocal: true, icon: CaseStudiesSVG },
  { title: 'Press', url: PATH.press, isLocal: true, icon: PressSVG },
  { title: 'About Us', url: PATH.aboutUs, isLocal: true, icon: AboutUsSVG },
  { title: 'Careers', url: PATH.careers, isLocal: true, icon: CareersSVG },
  { title: 'Support', url: PATH.support, isLocal: true, icon: SupportSVG },
]
export const demoDropdown = [
  { title: 'Playground', url: `${URL.hubUrl}playground/`, isLocal: false, icon: PlaygroundSVG },
  { title: 'Device Identification', url: PATH.demoUrl, isLocal: true, icon: IdentificationOverviewSVG },
  { title: 'By Use Case', url: URL.hubUrl, isLocal: false, icon: ByUseCaseSVG },
]

// Add a/b test variants here to avoid hydration issues
export const notificationBarPages = [
  { name: 'Homepage', pages: [PATH.home, PATH.homeTestA, PATH.homeTestB] },
  { name: 'Blog', pages: [PATH.blog] },
  { name: 'Products', pages: ['/products/'] },
  { name: 'Case Studies', pages: [PATH.caseStudies] },
  {
    name: 'Solutions and Use Cases',
    pages: [
      PATH.paymentFraud,
      PATH.accountTakeover,
      PATH.accountSharing,
      PATH.paymentFraud,
      PATH.ecommerce,
      PATH.bnpl,
      PATH.gaming,
      PATH.cryptocurrency,
      PATH.useCases,
    ],
  },
  { name: 'About', pages: [PATH.aboutUs] },
  { name: 'Contact (Sales, Support)', pages: [PATH.contactSales, PATH.support] },
  { name: 'Careers', pages: [PATH.careers] },
  { name: 'Press', pages: [PATH.press] },
  { name: 'FAQ', pages: [PATH.faq] },
  { name: 'Integrations and SDKs', pages: [PATH.integrations, PATH.sdks] },
  { name: 'Pricing', pages: [PATH.pricingUrl, '/pricing-a/', '/pricing-b/'] },
  { name: 'Demo', pages: [PATH.demoUrl, '/demo-a/', '/demo-b/'] },
  { name: 'GitHub', pages: [PATH.github] },
]
